import gql from 'graphql-tag';

export const unpinSectionContent = gql(`
  mutation unpinSectionContent($sectionId: UUID!, $contentId: UUID!) {
    unpinSectionContent(sectionId: $sectionId, contentId: $contentId)
  }
`);
